// extracted by mini-css-extract-plugin
export var container = "_aa-0";
export var icon = "_aa-1";
export var text = "_aa-2";